import IQACDynamicPage from '../../DynamicPage/IQACDynamicPage';
import pages from "../../Pages.json";
import TableComponent from '../../../components/Table/TableComponent';
import "./CollegeCouncil.scss";

const CollegeCouncil = () => {

    const collegeCouncil = pages['college-council'][0];
    const columns = ["S.No.", "Name", "Designation & Department","Position", "Email ID" ];
    const rows = [
        { name: "Shri. M. S. Faizal Khan", designation: "President", position: "President " , email : "nicefaizal@yahoo.co.in"},
        { name: "Janab Dr. A. P. Majeed Khan", designation: "Secretary", position: "Secretary", email : "info@niuniv.com" },
        { name: "Dr. R. Perumalsamy", designation: "Pro-Chancellor(Academic)", position: "Member", email : "info@niuniv.com" },
        { name: "Prof. Dr. K.A. Janardhanan", designation: "Pro Vice-Chancellor (Administration)", position: "Member", email : "info@niuniv.com" },
        { name: "Dr. R. Rajalakshmi", designation: "Asst. Prof. &  Head, Department of Computer Science", position: "Member", email : "rajalakshminatesh@gmil.com" },
        { name: "Dr. S. Padma Devi", designation: "Asst. Prof. & Head, Department of  Tamil", position: "Member", email : "padma101978@gmail.com" },
        { name: "Mrs. S. S. Bindu Lekha", designation: "Office Assistant", position: "Member", email : "lekhab734@gmail.com" },
    ];

    return (
        <section className="collegeCouncilMainContainer">
            <article className="firstSection">
                <IQACDynamicPage
                    title={collegeCouncil.title}
                    content={collegeCouncil.content}
                    secondtitle={collegeCouncil.secondtitle}
                />


                <article className='points-style'>
                    <ul className='points-ol-style'>
                        <li>Ensures efficient governance and decision-making.</li>
                        <li>Promotes transparency and accountability in administrative and financial matters.</li>
                        <li>Strengthens academic quality and innovation through curriculum improvements.</li>
                        <li>Enhances institutional reputation and credibility.</li>
                        <li>Supports student welfare and faculty development, fostering a positive learning environment.</li>

                    </ul>
                </article>

            </article>
            
            <article className="secondSection">
                <h2 style={{ color: "#116C4A" }}>College Council Member</h2>
                <TableComponent columns={columns} data={rows} />
            </article>
        </section>
    )
}

export default CollegeCouncil
